import dayjs from "dayjs";

const percentChange = (start, end) => (end - start) / start;

const prettyPercent = p => {
  p *= 100;
  if (isNaN(p)) {
    return "n/a";
  } else if (Math.abs(p) < 0.05) {
    return "0%";
  } else if (Math.abs(p) < 1) {
    return p.toFixed(1) + "%";
  } else {
    return Math.round(p).toLocaleString() + "%";
  }
};

const prettyPercentChange = (start, end) => prettyPercent(percentChange(start, end));

const getWhens = (timeframe, latestDay) => {
  const currWhen = {
    start: dayjs(latestDay).subtract(1, timeframe).add(1, "day").format("YYYY-MM-DD"),
    end: latestDay
  };

  const prevWhen = {
    start: dayjs(currWhen.start).subtract(1, timeframe).format("YYYY-MM-DD"),
    end: dayjs(currWhen.end).subtract(1, timeframe).format("YYYY-MM-DD")
  };

  const yearAgoWhen = {
    start: dayjs(currWhen.start).subtract(1, "year").format("YYYY-MM-DD"),
    end: dayjs(currWhen.end).subtract(1, "year").format("YYYY-MM-DD")
  }

  return { currWhen, prevWhen, yearAgoWhen };
};

const capitalize = s => s.slice(0, 1).toUpperCase() + s.slice(1);


export { percentChange, prettyPercentChange, prettyPercent, getWhens, capitalize };